import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  transition: color 180ms, background-color 180ms;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { useCheckbox } from '../checkbox/useCheckbox';
import { Tag } from '../tag/Tag';
var radioTagStyle = variant({
  key: 'radio.tag'
});
var StyledTag = styled(Tag)(_templateObject(), radioTagStyle);
export var RadioTag = function RadioTag(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      children = _ref.children,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["checked", "onChange", "children", "value"]);

  var _useCheckbox = useCheckbox({
    checked: checked,
    onChange: onChange
  }),
      isChecked = _useCheckbox.isChecked,
      handleChange = _useCheckbox.handleChange;

  var handleClick = function handleClick(e) {
    e.target.value = value;
    handleChange(e);
  };

  return (
    /*#__PURE__*/
    React.createElement(StyledTag, _extends({
      onClick: handleClick,
      variant: isChecked ? 'active' : null,
      checked: isChecked
    }, rest), children)
  );
};